import { PROMPT_PRESETS } from "@/config/presets";

type Props = { onSelect: (text: string) => void };

export function PromptPresets({ onSelect }: Props) {
  return (
    <div className="flex flex-wrap gap-2">
      {PROMPT_PRESETS.map((p) => (
        <button
          key={p.id}
          type="button"
          onClick={() => onSelect(p.text)}
          className="rounded-full border border-[var(--color-border)] bg-[var(--color-surface)] px-3 py-1 text-xs hover:bg-[var(--color-surface-muted)]"
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}
